import emptyDateObject from './emptyDateObject';
import { DateObject } from '../questionnaireHelpers';

export default function dateToObject(date: Date | null): DateObject {
	if (date) {
		return {
			year: String(date.getUTCFullYear()),
			month: String(date.getUTCMonth() + 1).padStart(2, '0'),
			day: String(date.getUTCDate()).padStart(2, '0')
		};
	}
	return emptyDateObject;
}
